import { styled } from '@mui/material';
import DropDown from 'Components/Forms/DropDown';
import { FieldWrapper } from 'DesignSystem';
import React, { FC } from 'react';
import { EAvailableSizes } from 'DesignSystem/types/size.types';

interface IAgroforestryDropdownProps {
  value?: boolean;
  onChange: (value?: boolean) => void;
}

type TAgroforestryOption = 'yes' | 'no' | 'unknown';

const StyledDropDown = styled(DropDown)(({ theme }) => ({
  '& .MuiSelect-select': {
    height: '30px !important',
    boxSizing: 'border-box',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
})) as typeof DropDown;

const AgroforestryDropdown: FC<IAgroforestryDropdownProps> = ({ value, onChange }) => {
  const AGROFORESTRY_OPTIONS: { value: TAgroforestryOption; label: string }[] = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
    { value: 'unknown', label: 'Unknown' },
  ];

  const agroforestryToOption = (value?: boolean): TAgroforestryOption => {
    if (value === true) return 'yes';
    if (value === false) return 'no';
    return 'unknown';
  };

  const optionToAgroforestry = (option: TAgroforestryOption): boolean | undefined => {
    if (option === 'yes') return true;
    if (option === 'no') return false;
    return undefined;
  };
  return (
    <FieldWrapper
      label="Agroforestry"
      fullWidth
      tooltip={{
        helperText:
          'Agroforestry is a land use management system where trees or shrubs are grown around or among crops or pastureland. This practice combines agriculture and forestry to create more diverse, productive, and sustainable land-use systems.',
        variant: 'INFO',
      }}
    >
      <StyledDropDown<TAgroforestryOption, { value: TAgroforestryOption; label: string }>
        currentValue={agroforestryToOption(value)}
        options={AGROFORESTRY_OPTIONS}
        keyField="value"
        onChange={option => onChange(optionToAgroforestry(option))}
        renderItems={option => option.label}
        placeholder="Select agroforestry status"
        variant="outlined"
        fullWidth
        size={EAvailableSizes.SMALL}
        data-testid="agroforestry-dropdown"
      />
    </FieldWrapper>
  );
};

export default AgroforestryDropdown;
